import { UI } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Box, Pressable } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { usePublicOfferAssetContext } from '../../../../../contexts/products/PublicOffer';
import { LateralBar } from '../../../components/LateralBar';
import { publicOfferConstants } from '../constants';
import { ListLoadingItemDesktop } from '../ListLoadingItem/desktop';

import { PublicOfferItemTypes } from '.';

export const PublicOfferItemDesktop: React.FC<PublicOfferItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = usePublicOfferAssetContext();
  const { infoGetter, selectedTab } = useGlobalAssetContext();

  const { Button, isSelected, forceLoading } = infoGetter('publicOffers', offer, 'offerId');

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected(offer);
  };

  const getFlex = (index: number) => {
    const currentHead = publicOfferConstants.tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  if (forceLoading) {
    return <ListLoadingItemDesktop />;
  }

  return (
    <TableContent
      direction="row"
      space={0}
      p={0}
      px={Spacing['inline.xxxs']}
      h="80px"
      isHighlighted={isSelected}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <UI.Tooltip testID="details-tooltip" label="Ver detalhes">
          <Pressable onPress={onOpenDetailsModal}>
            <UI.Icon name="Info" size="xs" />
          </Pressable>
        </UI.Tooltip>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{offer.offerType}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{offer.companyName}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{offer.offerName}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>{offer.isinCode}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{offer.alterationDateFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText>{offer.negotiationDateFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <TableContentItemText>{offer.liquidityDateFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(8)}>
        <TableContentItemText>{offer.limiter}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(9)}>
        <Box w={'100%'}>
          <Button
            id={selectedTab.typeGetterId}
            offer={offer}
            productContextConstant={selectedTab}
          />
        </Box>
      </TableContentItemColumn>
    </TableContent>
  );
};
